import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { FlowNode } from '../../../types/flowBuilder';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

const FormNode: React.FC<NodeProps<FlowNode['data']>> = ({ data, selected }) => {
  const fieldCount = data.config?.fields?.length || 0;

  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-gradient-to-r from-orange-400 to-orange-500 border-2 transition-all duration-200 ${
      selected ? 'border-orange-600 shadow-xl scale-105' : 'border-orange-300'
    }`}>
      <div className="flex items-center space-x-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <DocumentTextIcon className="w-5 h-5 text-white" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-white truncate">
            {data.label}
          </div>
          {data.description && (
            <div className="text-xs text-orange-100 truncate mt-1">
              {data.description}
            </div>
          )}
          
          {/* Field count */}
          <div className="text-xs text-orange-100 mt-1">
            {fieldCount} mező
          </div>
        </div>

        {/* Status indicator */}
        <div className="flex-shrink-0">
          <div className={`w-3 h-3 rounded-full ${
            data.hasError ? 'bg-red-500' : 'bg-green-400'
          }`} />
        </div>
      </div>

      {/* Field preview */}
      {data.config?.fields && data.config.fields.length > 0 && (
        <div className="mt-2 text-xs text-orange-100 bg-black bg-opacity-20 px-2 py-1 rounded">
          <div className="space-y-1">
            {data.config.fields.slice(0, 3).map((field: any, index: number) => (
              <div key={index} className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-orange-200 rounded-full" />
                <span className="truncate">{field.label || field.name}</span>
              </div>
            ))}
            {data.config.fields.length > 3 && (
              <div className="text-orange-200">
                +{data.config.fields.length - 3} további...
              </div>
            )}
          </div>
        </div>
      )}

      {/* Error message */}
      {data.hasError && data.errorMessage && (
        <div className="mt-2 text-xs text-red-200 bg-red-500 bg-opacity-20 px-2 py-1 rounded">
          {data.errorMessage}
        </div>
      )}

      {/* Submission data preview */}
      {data.executionData && (
        <div className="mt-2 text-xs text-orange-100 bg-black bg-opacity-20 px-2 py-1 rounded">
          <div className="font-mono">
            Kitöltve: {Object.keys(data.executionData).length} mező
          </div>
        </div>
      )}

      {/* Input handle - prefill data */}
      <Handle
        type="target"
        position={Position.Left}
        id="prefill"
        className="w-3 h-3 bg-white border-2 border-orange-500"
        style={{ left: -6 }}
      />

      {/* Output handle - form data */}
      <Handle
        type="source"
        position={Position.Right}
        id="formData"
        className="w-3 h-3 bg-white border-2 border-orange-500"
        style={{ right: -6 }}
      />
    </div>
  );
};

export default FormNode;
